export type { IAutoCompleteOption } from './autocomplete';

export { default } from './autocomplete';
